var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.blockType === _vm.BLOCK_TYPES.BOT_RESPONSE
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BLOCK_TYPES.BOT_RESPONSE },
        },
        [_vm._v("\n    send\n")]
      )
    : _vm.blockType === _vm.BLOCK_TYPES.START_POINT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BLOCK_TYPES.START_POINT },
        },
        [_vm._v("\n    home\n")]
      )
    : _vm.blockType === _vm.BLOCK_TYPES.ATTACHMENT_INPUT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BLOCK_TYPES.ATTACHMENT_INPUT },
        },
        [_vm._v("\n    attachment\n")]
      )
    : _vm.blockType === _vm.BLOCK_TYPES.FILTER
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BLOCK_TYPES.FILTER },
        },
        [_vm._v("\n    filter_alt\n")]
      )
    : _vm.blockType === _vm.BLOCK_TYPES.USER_INPUT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BLOCK_TYPES.USER_INPUT },
        },
        [_vm._v("\n    record_voice_over\n")]
      )
    : _vm.blockType === _vm.BLOCK_TYPES.GO_TO_STEP
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BLOCK_TYPES.GO_TO_STEP },
        },
        [_vm._v("\n    cable\n")]
      )
    : _vm.blockType === _vm.BLOCK_TYPES.ADD_TO_SEGMENT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BLOCK_TYPES.ADD_TO_SEGMENT },
        },
        [_vm._v("\n    pie_chart\n")]
      )
    : _vm.blockType === _vm.BLOCK_TYPES.REMOVE_FROM_SEGMENT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BLOCK_TYPES.REMOVE_FROM_SEGMENT },
        },
        [_vm._v("\n    pie_chart\n")]
      )
    : _vm.blockType === _vm.BLOCK_TYPES.DEFAULT_FALLBACK
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BLOCK_TYPES.DEFAULT_FALLBACK },
        },
        [_vm._v("\n    heart_broken\n")]
      )
    : _vm.blockType === _vm.BLOCK_TYPES.FALLBACK
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BLOCK_TYPES.FALLBACK },
        },
        [_vm._v("\n    heart_broken\n")]
      )
    : _vm.blockType === _vm.BLOCK_TYPES.QUESTION
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BLOCK_TYPES.QUESTION },
        },
        [_vm._v("\n    quiz\n")]
      )
    : _vm.blockType === _vm.BLOCK_TYPES.SET_ATTRIBUTE
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BLOCK_TYPES.SET_ATTRIBUTE },
        },
        [_vm._v("\n    data_object\n")]
      )
    : _vm.blockType === _vm.BLOCK_TYPES.CLOSE_CHAT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BLOCK_TYPES.CLOSE_CHAT },
        },
        [_vm._v("\n    mark_chat_read\n")]
      )
    : _vm.blockType === _vm.BLOCK_TYPES.SUCCESS
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BLOCK_TYPES.SUCCESS },
        },
        [_vm._v("\n    check_circle\n")]
      )
    : _vm.blockType === _vm.BLOCK_TYPES.FAILURE
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BLOCK_TYPES.FAILURE },
        },
        [_vm._v("\n    cancel\n")]
      )
    : _vm.blockType === _vm.BLOCK_TYPES.FLOW
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BLOCK_TYPES.FLOW },
        },
        [_vm._v("schema")]
      )
    : _vm.blockType === _vm.BLOCK_TYPES.CREATE_TICKET
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BLOCK_TYPES.CREATE_TICKET },
        },
        [_vm._v("\n    local_activity\n")]
      )
    : _vm.blockType === _vm.BLOCK_TYPES.TAG_CHAT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BLOCK_TYPES.TAG_CHAT },
        },
        [_vm._v("\n    bookmark\n")]
      )
    : _vm.blockType === _vm.BLOCK_TYPES.REMOVE_TAG
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BLOCK_TYPES.REMOVE_TAG },
        },
        [_vm._v("\n    bookmark_remove\n")]
      )
    : _vm.blockType === _vm.BLOCK_TYPES.TRANSFER_CHAT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BLOCK_TYPES.TRANSFER_CHAT },
        },
        [_vm._v("\n    support_agent\n")]
      )
    : _vm.blockType === _vm.BLOCK_TYPES.SEND_TRANSCRIPT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BLOCK_TYPES.SEND_TRANSCRIPT },
        },
        [_vm._v("\n    attach_email\n")]
      )
    : _vm.blockType === _vm.BLOCK_TYPES.SEND_SMS
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BLOCK_TYPES.SEND_SMS },
        },
        [_vm._v("\n    sms\n")]
      )
    : _vm.blockType === _vm.BLOCK_TYPES.SEND_MAIL
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BLOCK_TYPES.SEND_MAIL },
        },
        [_vm._v("\n    mail\n")]
      )
    : _vm.blockType === _vm.BLOCK_TYPES.CREATE_EVENT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BLOCK_TYPES.CREATE_EVENT },
        },
        [_vm._v("\n    event\n")]
      )
    : _vm.blockType === _vm.BLOCK_TYPES.CREATE_RESERVATION
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BLOCK_TYPES.CREATE_RESERVATION },
        },
        [_vm._v("\n    calendar_month\n")]
      )
    : _vm.blockType === _vm.BLOCK_TYPES.RESERVATION_OPEN_URL
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BLOCK_TYPES.RESERVATION_OPEN_URL },
        },
        [_vm._v("\n    event\n")]
      )
    : _vm.blockType === _vm.BLOCK_TYPES.RESERVATION_SELECT_DAY
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BLOCK_TYPES.RESERVATION_SELECT_DAY },
        },
        [_vm._v("\n    calendar_month\n")]
      )
    : _vm.blockType === _vm.BLOCK_TYPES.RESERVATION_EVENT_LIST
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BLOCK_TYPES.RESERVATION_EVENT_LIST },
        },
        [_vm._v("\n    event_note\n")]
      )
    : _vm.blockType === _vm.BLOCK_TYPES.RESERVATION_SELECT_TIME
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BLOCK_TYPES.RESERVATION_SELECT_TIME },
        },
        [_vm._v("\n    calendar_month\n")]
      )
    : _vm.blockType === _vm.BLOCK_TYPES.WEBHOOK
    ? _c(
        "span",
        {
          staticClass: "material-icons text-light",
          attrs: { "data-type": _vm.BLOCK_TYPES.WEBHOOK },
        },
        [_vm._v("\n    share\n")]
      )
    : _vm.blockType === _vm.BLOCK_TYPES.GET_LOCATION
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BLOCK_TYPES.GET_LOCATION },
        },
        [_vm._v("\n    location_on\n")]
      )
    : _vm.blockType === _vm.BLOCK_TYPES.SET_DEPARTMENT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BLOCK_TYPES.SET_DEPARTMENT },
        },
        [_vm._v("\n    category\n")]
      )
    : _vm.BLOCK_TYPES.AKINON_BLOCKS.includes(_vm.blockType)
    ? _c("img", {
        staticClass: "custom-block-logo",
        attrs: { src: "/static/img/akinon.png", "data-type": _vm.blockType },
      })
    : _vm.BLOCK_TYPES.IDEASOFT_BLOCKS.includes(_vm.blockType)
    ? _c("img", {
        staticClass: "custom-block-logo",
        attrs: { src: "/static/img/ideasoft.webp", "data-type": _vm.blockType },
      })
    : _vm.BLOCK_TYPES.PROBEL_BLOCKS.includes(_vm.blockType)
    ? _c("img", {
        staticClass: "custom-block-logo",
        attrs: {
          src: "/static/img/chatbot/probel.png",
          "data-type": _vm.blockType,
        },
      })
    : _vm.blockType === _vm.BLOCK_TYPES.SHOPIFY_ORDER_STATUS
    ? _c("img", {
        staticClass: "custom-block-logo",
        attrs: {
          src: "/static/img/shopify.png",
          "data-type": _vm.BLOCK_TYPES.SHOPIFY_ORDER_STATUS,
        },
      })
    : _vm.blockType === _vm.BLOCK_TYPES.SHOPIFY_PRODUCT_AVAILABILITY
    ? _c("img", {
        staticClass: "custom-block-logo",
        attrs: {
          src: "/static/img/shopify.png",
          "data-type": _vm.BLOCK_TYPES.SHOPIFY_PRODUCT_AVAILABILITY,
        },
      })
    : _vm.blockType === _vm.BLOCK_TYPES.SHOPIFY_SHOW_PRODUCTS
    ? _c("img", {
        staticClass: "custom-block-logo",
        attrs: {
          src: "/static/img/shopify.png",
          "data-type": _vm.BLOCK_TYPES.SHOPIFY_SHOW_PRODUCTS,
        },
      })
    : _vm.blockType === _vm.BLOCK_TYPES.AI_BOT_RESPONSE
    ? _c("img", {
        staticClass: "custom-block-logo",
        attrs: {
          src: "/static/img/openai.png",
          "data-type": _vm.BLOCK_TYPES.AI_BOT_RESPONSE,
        },
      })
    : _vm.blockType === _vm.BLOCK_TYPES.AI_CLASSIFICATION
    ? _c("AIClassificationIcon", {
        staticClass: "custom-block-logo",
        attrs: { "data-type": _vm.BLOCK_TYPES.AI_CLASSIFICATION },
      })
    : _vm.blockType === _vm.BLOCK_TYPES.AI_ASSISTANT
    ? _c(
        "div",
        {
          staticClass: "custom-block-logo ai-assistant",
          attrs: { "data-type": _vm.BLOCK_TYPES.AI_ASSISTANT },
        },
        [_c("OpenaiIcon")],
        1
      )
    : _vm.blockType === _vm.BLOCK_TYPES.CREATE_TASK
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BLOCK_TYPES.CREATE_TASK },
        },
        [_vm._v("\n    add_task\n")]
      )
    : _vm.blockType === _vm.BLOCK_TYPES.SUPPRESSION_ADD
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BLOCK_TYPES.SUPPRESSION_ADD },
        },
        [_vm._v("\n    block\n")]
      )
    : _vm.blockType === _vm.BLOCK_TYPES.SUPPRESSION_REMOVE
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BLOCK_TYPES.SUPPRESSION_REMOVE },
        },
        [_vm._v("\n    lock_open\n")]
      )
    : _vm.blockType === _vm.BLOCK_TYPES.B2CARGO_PRODUCT_STATUS
    ? _c("img", {
        staticClass: "custom-block-logo",
        attrs: {
          src: "/static/img/chatbot/b2cargo.png",
          "data-type": _vm.BLOCK_TYPES.B2CARGO_PRODUCT_STATUS,
        },
      })
    : _vm.blockType === _vm.BLOCK_TYPES.B2CARGO_LOGIN_USER
    ? _c("img", {
        staticClass: "custom-block-logo",
        attrs: {
          src: "/static/img/chatbot/b2cargo.png",
          "data-type": _vm.BLOCK_TYPES.B2CARGO_LOGIN_USER,
        },
      })
    : _vm.blockType === _vm.BLOCK_TYPES.DEFAULT_TIMEOUT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BLOCK_TYPES.DEFAULT_TIMEOUT },
        },
        [_vm._v("\n    timer\n")]
      )
    : _vm.blockType === _vm.BLOCK_TYPES.TIMEOUT
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BLOCK_TYPES.TIMEOUT },
        },
        [_vm._v("\n    timer\n")]
      )
    : _vm.blockType === _vm.BLOCK_TYPES.SEND_WP_BUSINESS_MESSAGE
    ? _c(
        "span",
        {
          staticClass: "material-icons",
          attrs: { "data-type": _vm.BLOCK_TYPES.SEND_WP_BUSINESS_MESSAGE },
        },
        [_vm._v("\n    send\n")]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }